"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFlywireReentry = isFlywireReentry;
function isFlywireReentry() {
  if (typeof window === 'undefined' || !window.location) return false;
  var search = window.location.search;
  return search.includes('reentry=flywire');
}